import {AnalyticsConsent} from '../analytics/AnalyticsConsent';
import {FittingDiscountCapture} from '../fittings/FittingDiscount';
import {AdminInvoicesPage} from '../admin/invoices/AdminInvoicesPage';
import {FittingPage,FittingStatusPage} from '../fittings/FittingPage';
import {ReferralCapture} from '../partner/referral';
import {PartnerPage,LegacyPartnerRedirect} from '../partner/PartnerPage';
import {AdminFittingsPage} from '../admin/fittings/AdminFittingsPage';
import {AdminSettingsPage} from '../admin/settings/AdminSettingsPage';
import {SiteSectionGate} from '../siteSettings/SiteSettingsProvider';
import { AccountReservationsPage } from '../pages/AccountPage/AccountReservationsPage';
import { FavoritesProvider } from '../storefront/favorites/FavoritesProvider';
import { FavoritesPage } from '../storefront/favorites/FavoritesPage';
import AccountPage from '../pages/AccountPage/AccountPage';
import { BookingInformationPage } from '../storefront/payments/BookingInformationPage';
import { lazy, useEffect, useState } from 'react';
import { ThemeProvider } from 'styled-components';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import theme from './theme';
import { RestrictedRoute } from './RestrictedRoute';
import { refreshUser } from '../redux/auth/operations';
import { useAuth } from 'hooks';
import PrivacyPolicyPage from 'pages/PrivacyPolicyPage/PrivacyPolicyPage';
import RefreshPasswordPage from 'pages/RefreshPasswordPage/RefreshPasswordPage';
import { GlobalStyles } from '../design-system/styles/GlobalStyles';
import { StorefrontLayout } from '../layouts/StorefrontLayout';
import { ReservationFlowLayout } from '../layouts/ReservationFlowLayout';
import { HowRentalPage, FaqPage, ContactPage, CookiesPage } from '../storefront/InformationPages';
import { routes } from '../navigation/routes';
import { RouteScrollRestoration } from '../navigation/RouteScrollRestoration';
import { ModalAuthContext } from '../context/ModalAuthContext';
import Modal from './Modals/Modal';
import ModalRegister from './Modals/ModalRegister/ModalRegister';
import { AdminAccessBoundary } from '../admin/auth/AdminAccessBoundary';
import { AdminLayout } from '../admin/layout/AdminLayout';
import { adminRoutes } from '../admin/navigation/adminRoutes';
import { AdminReservationsPage } from '../admin/reservations/AdminReservationsPage';
import { AdminReservationDetailPage } from '../admin/reservations/AdminReservationDetailPage';
import { AdminReservationCalendarPage } from '../admin/calendar/AdminReservationCalendarPage';
import { AdminProductsPage } from '../admin/products/AdminProductsPage';
import { AdminProductCorePage } from '../admin/products/AdminProductCorePage';
import { AdminHomePage } from '../admin/pages/AdminPlaceholders';

import { BookingProvider } from '../storefront/booking/BookingProvider';
import { CataloguePage } from '../storefront/CataloguePage';
import { ProductDetailPage } from '../storefront/ProductDetailPage';
import { BookingPage } from '../storefront/booking/BookingPage';
import { BookingStatusPage } from '../storefront/booking/BookingStatusPage';

const AboutUsPage = lazy(() => import('../pages/AboutUsPage/AboutUsPage'));
const MainPage = lazy(() => import('../pages/MainPage/MainPage'));
const ConfirmEmailPage = lazy(
  () => import('../pages/ConfirmEmailPage/ConfirmEmailPage')
);
const NotFoundPage = lazy(() => import('../pages/NotFoundPage/NotFoundPage'));

function App() {
  const [currentTheme, setCurrentTheme] = useState('light');
  const [isOpenModalAuth, setIsOpenModalAuth] = useState(false);
  const [authNotice, setAuthNotice] = useState('');
  useEffect(() => { if (!isOpenModalAuth) setAuthNotice(''); }, [isOpenModalAuth]);
  const dispatch = useDispatch();
  const { token, isLoggedIn, isRefreshing, user } = useAuth();

  if (false) setCurrentTheme('light');

  useEffect(() => {
    dispatch(refreshUser());
  }, [dispatch, token]);

  useEffect(() => {
    if (isLoggedIn && isOpenModalAuth) setIsOpenModalAuth(false);
  }, [isLoggedIn, isOpenModalAuth]);

  return (
    <ThemeProvider theme={theme[currentTheme]}>
      <GlobalStyles />
      <AnalyticsConsent />
      <ModalAuthContext.Provider
        value={{ isOpenModalAuth, setIsOpenModalAuth, setAuthNotice }}
      >
        <FavoritesProvider><BookingProvider
          sessionPending={isRefreshing || Boolean(token && (!isLoggedIn || !(user?.userID || user?._id)))}
          session={token && isLoggedIn && (user?.userID || user?._id) ? { accountId: String(user.userID || user._id), token } : null}
          contactProfile={isRefreshing ? undefined :
            token && isLoggedIn && user && (user.userID || user._id) ? {
              accountId: String(user.userID || user._id),
              firstName: user.firstName,
              lastName: user.lastName,
              email: user.email,
              phone: user.primaryPhoneNumber,
            } : null}
        >
          <ReferralCapture /><FittingDiscountCapture />
          <Routes>
            <Route
              element={
                <RestrictedRoute
                  redirectTo="/"
                  redirectBack={routes.account}
                  component={<StorefrontLayout />}
                />
              }
            >
              <Route path="/zkouska" element={<FittingPage/>}/>
              <Route path="/partner" element={<LegacyPartnerRedirect/>}/>
              <Route path="/partner/blaze" element={<PartnerPage/>}/>
              <Route path="/zkouska/:number" element={<FittingStatusPage/>}/>
              <Route path={routes.home} element={<MainPage />} />

              {/* Canonical storefront routes. */}
              <Route path={routes.dresses} element={<CataloguePage />} />
              <Route path={routes.suits} element={<SiteSectionGate section="suits"><CataloguePage /></SiteSectionGate>} />
              <Route path={routes.familyLooks} element={<SiteSectionGate section="familyLooks"><CataloguePage /></SiteSectionGate>} />
              <Route path={routes.newArrivals} element={<CataloguePage />} />
              <Route path={routes.rental} element={<HowRentalPage />} />
              <Route path={routes.search} element={<CataloguePage />} />
              <Route
                path={routes.favourites}
                element={<FavoritesPage />}
              />
              <Route
                path={routes.account}
                element={<AccountPage />}
              />
              <Route
                path={routes.accountReservations}
                element={<AccountReservationsPage />}
              />
              <Route
                path={routes.faq}
                element={<FaqPage />}
              />
              <Route
                path={routes.rentalTerms}
                element={<BookingInformationPage />}
              />
              <Route
                path={routes.contact}
                element={<ContactPage />}
              />
              <Route path={routes.terms} element={<BookingInformationPage />} />
              <Route path={routes.privacy} element={<PrivacyPolicyPage />} />
              <Route
                path={routes.cookies}
                element={<CookiesPage />}
              />
              <Route
                path={routes.productPattern}
                element={<ProductDetailPage />}
              />


              {/* One catalogue and API for canonical and historical category links. */}
              <Route path="/popular" element={<CataloguePage />} />
              <Route path="/forMen/*" element={<CataloguePage />} />
              <Route path="/forWomen/*" element={<CataloguePage />} />
              <Route path="/forChildren/*" element={<CataloguePage />} />
              <Route path="/decorAndToys/*" element={<CataloguePage />} />
              <Route path="/aboutUs" element={<AboutUsPage />} />
              <Route path="/confirmEmail" element={<ConfirmEmailPage />} />
              <Route
                path="/refreshPassword"
                element={<RefreshPasswordPage />}
              />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />

              {/* Historical links resolve to the current customer experience. */}
              <Route path="/my-account/favorite/*" element={<Navigate to={routes.favourites} replace />} />
              <Route path="/my-account/my-orders/*" element={<Navigate to={routes.accountReservations} replace />} />
              <Route path="/my-account/my-purchases/*" element={<Navigate to={routes.accountReservations} replace />} />
              <Route path="/my-account/rent-in/*" element={<Navigate to={routes.accountReservations} replace />} />
              <Route path="/my-account/cart/*" element={<Navigate to={routes.reservation} replace />} />
              <Route path="/my-account/*" element={<Navigate to={routes.account} replace />} />
              <Route path="/favorite/*" element={<Navigate to={routes.favourites} replace />} />
              <Route path="/cart/*" element={<Navigate to={routes.reservation} replace />} />
              <Route path="*" element={<NotFoundPage />} />
            </Route>

            <Route path={adminRoutes.root} element={<AdminAccessBoundary />}>
              <Route element={<AdminLayout />}>
                <Route index element={<AdminHomePage />} />
                <Route path={adminRoutes.invoices} element={<AdminInvoicesPage/>}/>
                <Route path={adminRoutes.fittings} element={<AdminFittingsPage/>}/>
                <Route path={adminRoutes.fittingDetail} element={<AdminFittingsPage/>}/>
                <Route path={adminRoutes.settings} element={<AdminSettingsPage />} />
                <Route
                  path={adminRoutes.products}
                  element={<AdminProductsPage />}
                />
                <Route
                  path={adminRoutes.productNew}
                  element={<AdminProductCorePage mode="create" />}
                />
                <Route
                  path={adminRoutes.productDetail}
                  element={<AdminProductCorePage mode="edit" />}
                />
                <Route
                  path={adminRoutes.reservations}
                  element={<AdminReservationsPage />}
                />
                <Route
                  path={adminRoutes.reservationDetail}
                  element={<AdminReservationDetailPage />}
                />
                <Route
                  path={adminRoutes.calendar}
                  element={<AdminReservationCalendarPage />}
                />
              </Route>
            </Route>

            <Route path={routes.reservationStatus} element={<ReservationFlowLayout />}>
              <Route index element={<BookingStatusPage />} />
            </Route>
            {/* Focused customer reservation flow. */}
            <Route
              path={routes.reservation}
              element={<ReservationFlowLayout />}
            >
              <Route index element={<BookingPage />} />
            </Route>
          </Routes>
          <RouteScrollRestoration />
        </BookingProvider></FavoritesProvider>

        {isOpenModalAuth && !isLoggedIn ? (
          <Modal
            authModal
            prohibitClosingByBackdrop
            closeModal={() => setIsOpenModalAuth(false)}
          >
            <ModalRegister authNotice={authNotice} handleCloseModal={() => setIsOpenModalAuth(false)} />
          </Modal>
        ) : null}
      </ModalAuthContext.Provider>
    </ThemeProvider>
  );
}

export default App;
